import React, { Component } from 'react'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';

import Input from '@material-ui/core/Input';
import SearchIcon from '@material-ui/icons/Search';
import InfoIcon from '@material-ui/icons/Info';
import {convertISODateTimeToBRLocale} from "../../../common/Util";
import FormControl from "@material-ui/core/FormControl/FormControl";
import InputLabel from "@material-ui/core/InputLabel/InputLabel";
import Select from "@material-ui/core/Select/Select";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import AutoclaveCiclosTabela from "./AutoclaveCiclosTabela";


const styles = theme => ({
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8
    },
    newServiceOrderTooltip: {
        position: 'fixed',
        top: '90vh',
        right: '2vh',
    },
    leftMargin: {
        marginLeft: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1)
    },
    infoIcon: {
        verticalAlign: "middle"
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
});

class AutoclaveCiclosMainView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputServiceOrderId: props.serviceOrderId || ''

        }

        this.handleChange = this.handleChange.bind(this);

    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    renderSearchComponent() {
     //   console.log("renderSearch");
        return null;
    }

  renderContent() {
      const {  ciclos } = this.props;
   //   console.log("renderContent");
      return (
          <React.Fragment>
              <Grid item  xs={12} sm={12} lg={12} xl={12}>
                  <Typography variant="h4" align="center" >
                      AUTOCLAVES - CICLOS
                  </Typography>
              </Grid>
              <AutoclaveCiclosTabela
                  ciclos={ciclos}
               />
          </React.Fragment>
      );
  }


    renderCiclos() {

        return (
            <React.Fragment>
                {this.renderSearchComponent()}
                {this.renderContent()}
            </React.Fragment>
        )
    }

    renderNoDataScreen() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                {this.renderSearchComponent()}
                <Typography align="center">
                    <InfoIcon className={classes.infoIcon} /> Por favor informe a Ordem de Serviço para visualizar detalhes.
                </Typography>
            </React.Fragment>
        )
    }

    renderLoadingScreen() {
        const { classes } = this.props;
        return (
            <React.Fragment>
                {this.renderSearchComponent()}
                <div align="center">
                    <CircularProgress className={classes.progress} />
                </div>
            </React.Fragment>
        )
    }


    render() {
        const { isLoading, ciclos } = this.props;
        return (
            <React.Fragment>
                {isLoading ?
                    this.renderLoadingScreen() : ciclos ?
                        this.renderCiclos() : this.renderNoDataScreen()}
            </React.Fragment>
        );
    }
}

export default (withStyles(styles, {withTheme: true}))(AutoclaveCiclosMainView);
